import { RootState } from '~/store';

export const getPdfReducer = (state: RootState) => state.pdfReducer;
